import { Link, NavLink, useNavigate } from "react-router-dom";
import { Crown, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const navItem = "px-3 py-1.5 text-xs uppercase tracking-[0.2em] text-white/50 hover:text-white transition-colors";
  const navItemActive = "text-white";

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white font-mono-ui" data-testid="admin-layout">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-black/60 border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <Link to="/admin" className="flex items-center gap-2" data-testid="admin-brand-link">
              <Crown className="w-4 h-4 text-amber-400" />
              <span className="font-display font-bold tracking-tight text-base">VAWWORLD</span>
              <span className="text-white/30 text-xs uppercase tracking-[0.3em] ml-2 hidden sm:inline">Control Room</span>
            </Link>
            <nav className="flex items-center gap-1">
              <NavLink
                to="/admin"
                end
                className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""}`}
                data-testid="admin-nav-dashboard"
              >
                Dashboard
              </NavLink>
              <NavLink
                to="/admin/analytics"
                className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""}`}
                data-testid="admin-nav-analytics"
              >
                Analytics
              </NavLink>
              <NavLink
                to="/admin/users"
                className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""}`}
                data-testid="admin-nav-users"
              >
                Users
              </NavLink>
              <NavLink
                to="/admin/domains"
                className={({ isActive }) => `${navItem} ${isActive ? navItemActive : ""}`}
                data-testid="admin-nav-domains"
              >
                Domains
              </NavLink>
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-white/40 hidden md:inline" data-testid="admin-user-email">
              {user?.email}
            </span>
            <Button
              variant="ghost"
              size="sm"
              className="text-white/60 hover:text-white rounded-none h-8"
              onClick={() => {
                logout();
                navigate("/login");
              }}
              data-testid="admin-logout-button"
            >
              <LogOut className="w-3.5 h-3.5 mr-1.5" />
              <span className="text-xs uppercase tracking-widest">Sign out</span>
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-[1400px] mx-auto px-6 py-8">{children}</main>
      <footer className="border-t border-white/5 mt-12">
        <div className="max-w-[1400px] mx-auto px-6 py-6 text-xs text-white/30 flex items-center justify-between">
          <span>© Vawworld OTT • Phase 1</span>
          <a
            href="/api/docs"
            target="_blank"
            rel="noreferrer"
            className="hover:text-white/60 inline-flex items-center gap-1"
            data-testid="admin-api-docs-link"
          >
            API Docs <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </footer>
    </div>
  );
}
